import { render } from "./TransactionIndex.vue?vue&type=template&id=436057b3"
import script from "./TransactionIndex.vue?vue&type=script&lang=js"
export * from "./TransactionIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__